import { type SelectOption } from "@via/utils/interfaces.tsx";

export const isSingleSelectOption = (
  value: SelectOption | readonly SelectOption[] | null | undefined
): value is SelectOption => !!value && !Array.isArray(value);
